export default "__VITE_ASSET__BL4ePGcy__"